// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin[data-v-0f2ce8a6]{margin-bottom:20px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
